import { createTheme } from '@mui/material';

export const theme = createTheme({
	typography: {
		fontFamily: 'Pretendard-Regular, sans-serif',
		fontWeightRegular: 400,
	},
	palette: {
		primary: {
			main: '#2B6FF3',
		},
	},
});
